import { 
    MessageResponseDto, 
    GetEmploymentStatusDto, 
    CreateEmploymentStatusDto, 
    EditEmploymentStatusDto,
    UtilEmploymentStatusControllerGet200Response,
    UtilityEmploymentStatusApiFp,
    DeleteEmploymentStatusDto,
} from "@api/api";
import { apiConfig } from "@core/query/config.query";
import { QueryKey } from "@core/query/query-key.enum";

export type GetResponseEmploymentStatusModel = UtilEmploymentStatusControllerGet200Response;
export type GetEmploymentStatusModel = GetEmploymentStatusDto;
export type MutateResponseEmploymentStatusModel = MessageResponseDto;
export type CreateEmploymentStatusModel = CreateEmploymentStatusDto;
export type UpdateEmploymentStatusModel = EditEmploymentStatusDto;
export type DeleteEmploymentStatusModel = DeleteEmploymentStatusDto;

export const apiEmploymentStatusFp =  UtilityEmploymentStatusApiFp(apiConfig);
export const getEmploymentStatusController = apiEmploymentStatusFp.utilEmploymentStatusControllerGet;
export const createEmploymentStatusController = apiEmploymentStatusFp.utilEmploymentStatusControllerCreate;
export const updateEmploymentStatusController = apiEmploymentStatusFp.utilEmploymentStatusControllerEdit;
export const deleteEmploymentStatusController = apiEmploymentStatusFp.utilEmploymentStatusControllerDelete;

export const QueryKeyEmploymentStatus = QueryKey.EmploymentStatus;